/**
 * Shotgun shells. Heavier per round than anything else, and a small stack, so a shotgun build pays
 * for itself in carried weight.
 */

import type { AmmoItem } from '@/sim/items/itemContract';

export const SHOTGUN_SHELLS = {
  id: 'shotgunShells',
  kind: 'ammo',
  label: 'Shotgun shells',
  description: 'Waxed paper hulls. Keep dry, keep away from children, keep loaded.',
  rarity: 'common',
  weightKg: 0.05,
  stackLimit: 60,
  equip: null,
  damageTypeId: 'ballistic',
  roundsPerUnit: 1,
} as const satisfies AmmoItem;
